import { Box, Divider, Paper, Tooltip, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import TextField from "../../components/TextField";
import { calculateValueFromEvent } from "../../components/Utils";
import { useDebounce } from "../../components/CustomHooks";
import useApi, { WEB_SOCKET_TOPIC_CARRILES } from "../../api";
import TableLoader from "../../components/TableLoader";
import EmptyStateLabel from "../../components/EmptyStateLabel";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { green, grey, lightGreen, red } from "@mui/material/colors";
import { consultarCarriles } from "../../api/controlador";
import Icon from "@mdi/react";
import { mdiCarArrowRight } from '@mdi/js';
import { mdiCarArrowLeft } from '@mdi/js';
import { mdiSwapHorizontal } from '@mdi/js';
import { useSubscription } from "react-stomp-hooks";
import { isJSON } from "validator";
import { isArray } from "lodash";

export const COMBO_CARRIL_RENDER = (carril) => {
    return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
        {carril.tipo.toUpperCase().includes('ENTRADA') ? <Icon path={mdiCarArrowRight} size={1} color={lightGreen[400]} /> : <Icon path={mdiCarArrowLeft} size={1} color={red[500]} />}
        {carril.nombre}
    </Box>;
}

const defaultFiltros = {
    //estacionamientoId: '',
    query: '',
}

export default function ListadoCarriles({ ...props }) {
    // const { reload } = props;
    const navigate = useNavigate();
    //const { cuenta } = useContext(AppContext);

    const [filtros, setFiltros] = useState(defaultFiltros);
    const debouncedSearchTerm = useDebounce(filtros.query, 300);

    const [carriles, setCarriles] = useState(null);
    const [carrilesFiltrados, setCarrilesFiltrados] = useState(null);

    const [{ data: carrilesData, loading: loadingCarriles }, carrilesApi] = useApi();

    useSubscription(WEB_SOCKET_TOPIC_CARRILES, (message) => {
        console.log('Mensaje desde el websocket para los carriles', message);
        if (isJSON(message.body)) {
            const messageData = JSON.parse(message.body);
            if (messageData && isArray(messageData)) {
                //console.log('Mensaje de carriles', messageData);
                setCarriles(messageData);
                if (filtros.query === '') {
                    setCarrilesFiltrados(messageData);
                } else {
                    setCarrilesFiltrados(messageData.filter(carril => carril.nombre.toLowerCase().includes(filtros.query.toLowerCase())));
                }
            }
        }
    });

    useEffect(() => {
        realizarConsultaCarriles();
    }, []);

    // useEffect(() => {
    //     if (reload) {
    //         realizarConsultaCarriles();
    //     }
    // }, [reload]);

    // useEffect(() => {
    //     if (filtros.estacionamientoId) {
    //         setFiltros({ ...filtros, query: '' });
    //         realizarConsultaCarriles(true);
    //     }
    // }, [filtros.estacionamientoId]);


    useEffect(() => {
        if (carrilesData) {
            setCarriles(carrilesData || [])
            setCarrilesFiltrados(carrilesData || [])
        }
    }, [carrilesData]);

    useEffect(() => {
        if (debouncedSearchTerm) {
            //realizarConsultaCarriles(true);
            console.log('Buscando carriles con:', debouncedSearchTerm);
            setCarrilesFiltrados(carriles.filter(carril => carril.nombre.toLowerCase().includes(debouncedSearchTerm.toLowerCase())));
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        if (filtros.query === '' && carriles) {
            //realizarConsultaCarriles(true);
            setCarrilesFiltrados(carriles);
        }
    }, [filtros.query]);

    const handleChangeValue = name => event => {
        const value = calculateValueFromEvent(event);
        setFiltros({ ...filtros, [name]: value });
    }

    const realizarConsultaCarriles = () => {
        setCarriles(null);
        setCarrilesFiltrados(null);
        carrilesApi(consultarCarriles()); //normalizeFiltros(filtros)));
    }

    const columns = useMemo(() => [
        {
            field: 'id', headerName: 'Id', width: 60, align: 'center', headerAlign: 'center',
        },
        {
            field: 'nombre', headerName: 'Carril', minWidth: 250, flex: 1,
        },
        {
            field: 'tipo', headerName: 'Tipo', minWidth: 135, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                const colorStatusReversible = params.row.reversibleOn ? lightGreen[400] : grey[300];
                const iconoReversible = params.row.reversible ? <Tooltip title={params.row.reversibleNombre}><Icon path={mdiSwapHorizontal} size={1} color={colorStatusReversible} /></Tooltip> : null;
                return params.row.tipo.toUpperCase().includes('ENTRADA') ?
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Icon path={mdiCarArrowRight} size={1} color={lightGreen[400]} /> Entrada{iconoReversible}</Box>
                    : <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Icon path={mdiCarArrowLeft} size={1} color={red[500]} /> Salida{iconoReversible}</Box>
            },
        },
        {
            field: 'activo', headerName: 'Estatus', width: 95, align: 'center', headerAlign: 'center',
            renderCell: (params) => params.row.activo === true ? <><span style={{ color: green[600] }}>Activo</span></> : <><span style={{ color: red[500] }}>Inactivo</span></>,
        },
    ], []);

    return (
        <>
            <Typography variant="body1" color="secondary" sx={{ fontWeight: 450 }}>Carriles del estacionamiento</Typography>
            <TextField
                fullWidth
                clearable
                value={filtros.query}
                onChange={handleChangeValue('query')}
                label="Nombre del carril"
            />
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Box sx={{ mt: 2 }}>
                {loadingCarriles &&
                    <TableLoader columns={columns} rowsNum={5} />
                }
                {carriles && carriles.length === 0 &&
                    <EmptyStateLabel text="No existen carriles con esos criterios" />
                }
                {carriles && carriles.length > 0 &&
                    <Paper elevation={0} sx={{ width: '100%', borderRadius: 6 }}>
                        <DataGrid
                            sx={{ borderRadius: 6 }}
                            autoHeight
                            disableRowSelectionOnClick
                            hideFooterPagination
                            columns={columns}
                            rows={carrilesFiltrados}
                            loading={loadingCarriles}
                            onRowClick={(params, event) => {
                                navigate(`/registros/carril/${params.row.id}`);
                            }}
                        />
                    </Paper>
                }
            </Box>
        </>
    );
}